import { Box } from "@mui/material";

export const LANGUAGE_OPTIONS = {
  en: { flag: "/flags/en.svg", short: "EN", name: "English" },
  de: { flag: "/flags/de.svg", short: "DE", name: "Deutsch" },
  ar: { flag: "/flags/ar.svg", short: "AR", name: "العربية" },
};

const LanguageLabel = ({ language, full = false }) => {
  const option = LANGUAGE_OPTIONS[language] || LANGUAGE_OPTIONS.en;
  return (
    <Box
      component="span"
      sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 0.75, whiteSpace: "nowrap" }}
    >
      <Box
        component="img"
        src={option.flag}
        alt=""
        aria-hidden="true"
        sx={{ width: 24, height: 16, objectFit: "cover", borderRadius: "2px", boxShadow: "0 0 0 1px rgba(0,0,0,.18)", flexShrink: 0 }}
      />
      <Box component="span">{full ? option.name : option.short}</Box>
    </Box>
  );
};

export default LanguageLabel;
